import { createFileRoute } from '@tanstack/react-router';

import { MaterialsPage } from '@/features/teacher/MaterialsPage';

export const Route = createFileRoute('/_authed/teacher/materials')({
  validateSearch: (search): { group?: string; subject?: string } => ({
    group: typeof search.group === 'string' ? search.group : undefined,
    subject: typeof search.subject === 'string' ? search.subject : undefined,
  }),
  component: MaterialsPage,
});
